"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReservationAudio = void 0;
const react_1 = require("react");
const toolbox_1 = require("@streem/toolbox");
const media_1 = require("../media");
const logger_1 = require("../util/logger");
const LOCAL_STORAGE_RESERVATION_PLAY_BUCKET = 'LS_RESERVATION_PLAY_BUCKET';
function useReservationAudio() {
    const timeout = (delay) => {
        return new Promise(res => setTimeout(res, delay));
    };
    const repeatChime = (0, react_1.useCallback)((reservationId, times, delay, fnToRepeat) => __awaiter(this, void 0, void 0, function* () {
        let remainingTimes = times;
        while (remainingTimes > 0 && getReservationPlayBucket()[reservationId]) {
            yield fnToRepeat();
            const timesPlayed = times - remainingTimes + 1;
            logger_1.logger.info(`Reservation chime has been played ${timesPlayed} time(s)`);
            yield timeout(delay);
            remainingTimes--;
        }
    }), []);
    (0, react_1.useEffect)(() => {
        return () => {
            media_1.audio.removeReservationAudioListener();
        };
    }, []);
    const getReservationPlayBucket = () => JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_RESERVATION_PLAY_BUCKET) || '{}');
    const clearReservationPlayBucket = () => window.localStorage.removeItem(LOCAL_STORAGE_RESERVATION_PLAY_BUCKET);
    const setRoomIdPlayingStatus = (0, react_1.useCallback)((reservationId, isPlaying = false) => {
        const reservationPlayBucket = getReservationPlayBucket();
        reservationPlayBucket[reservationId] = isPlaying;
        window.localStorage.setItem(LOCAL_STORAGE_RESERVATION_PLAY_BUCKET, JSON.stringify(reservationPlayBucket));
    }, []);
    const playReservationAudio = (0, react_1.useCallback)((reservationId, times = 1, delay = 5000) => __awaiter(this, void 0, void 0, function* () {
        if (!reservationId)
            return;
        setRoomIdPlayingStatus(reservationId, true);
        yield repeatChime(reservationId, times, delay, media_1.audio.playReservationAudio);
    }), [repeatChime, setRoomIdPlayingStatus]);
    const pauseReservationAudio = (0, react_1.useCallback)(() => {
        // Don't need to log or clear bucket for non reservation workflows
        const reservationBucket = getReservationPlayBucket();
        if (Object.keys(reservationBucket).length === 0)
            return;
        // Cleaning the reference, since there can only be one reservation per expert, otherwise, only the reservation reference must be cleaned.
        clearReservationPlayBucket();
    }, []);
    const usePlayReservation = (reservationSid) => {
        (0, react_1.useEffect)(() => {
            const playReservationAudioAsync = () => __awaiter(this, void 0, void 0, function* () {
                try {
                    logger_1.logger.info(`Attempting to play reservation ringtone for reservationSid=${reservationSid} through preferredAudioOutputId=${(0, toolbox_1.getPreferredAudioOutputId)()}`);
                    yield playReservationAudio(reservationSid, 4, 5000);
                }
                catch (error) {
                    logger_1.logger.warn(`Failed to play Reservation ringtone for reservationSid=${reservationSid} through preferredAudioOutputId=${(0, toolbox_1.getPreferredAudioOutputId)()} ${error}`);
                }
            });
            playReservationAudioAsync();
            return pauseReservationAudio;
        }, [reservationSid]);
    };
    // restrict this to reservation audio, because we don't want users of the standard ringtone to remove the event listener
    return {
        playReservationAudio,
        pauseReservationAudio,
        usePlayReservation,
    };
}
exports.useReservationAudio = useReservationAudio;
//# sourceMappingURL=use_reservation_audio.js.map